
import { useEffect, useState } from 'react';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { FaWeight } from 'react-icons/fa'
import { FiUpload } from 'react-icons/fi';
import { useMyContext } from '../../../../context/MyContext';
import StatusRaised from '../../../../component/b2c/models/statusRaised';
import '../../../../css/custom-scrollbar.css'
import { toast } from 'react-toastify';
import axios from 'axios';
import { Base_Url, dispute_action, weightListByStatus, weightListStatusBylosed, weightListStatusByAccept, weightDisputesAllforUser } from '../../../../config/config'


const WeightDisputeDashboard = () => {
  const [activeTab, setActiveTab] = useState('action');
  const [selectAll, setSelectAll] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [actionRequiredData, setActionrequiredData] = useState([]);
  const [acceptData, setAcceptData] = useState([]);
  const [closedData, setClosedData] = useState([]);
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCustomer, setTotalCustomers] = useState(0)
  const [selectedWaybillNo, setSelectedWaybillNo] = useState()
  const [allWeightDisputess, setAllWeightDisputes] = useState([]);
  const [allSellerId, setAllSelerId] = useState();

  const handleViewClick = (waybill) => {
    setSelectedWaybillNo(waybill)
    setIsPopupOpen(true);
  };
  const handleClose = () => {
    setIsPopupOpen(false);
  };


  // useEffect(()=>{
  //   getWeightDisputesDataById()
  // },[limit,currentPage])



  useEffect(() => {
    if (activeTab === 'accepted') {
      getAcceptData();
    } else if (activeTab === 'action') {
      getWeightDisputesData();
    }
    else if (activeTab === 'disputes') {
      allWeightDisputes();
    }
    else if (activeTab === 'closed') {
      getClosedData();
    }
  }, [activeTab, limit, currentPage]);

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handlePaginationChange = (e, value) => {
    setCurrentPage(value);
  };


  const tabs = [
    { id: 'action', label: 'Action Required Count' },
    { id: 'closed', label: 'Closed Count' },
    { id: 'accepted', label: 'Accepted' },
    { id: 'disputes', label: 'All Disputes' },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setTotalCustomers(0);
  }
  const getWeightDisputesData = async () => {
    const url = `${Base_Url}${weightListByStatus}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setActionrequiredData(data.data);
        setTotalCustomers(data.pagination.total_records);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const getClosedData = async () => {
    const url = `${Base_Url}${weightListStatusBylosed}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setClosedData(data.data);
        setTotalCustomers(data.pagination.total_records);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const getAcceptData = async () => {
    const url = `${Base_Url}${weightListStatusByAccept}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setAcceptData(data.data);
        setTotalCustomers(data.pagination.total_records);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const allWeightDisputes = async () => {
    const url = `${Base_Url}${weightDisputesAllforUser}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setAllWeightDisputes(data.data);
        setTotalCustomers(data.pagination.total_records);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleAccept = async (row) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');

    const formData = new FormData();
    formData.append("waybill", row.waybill);
    formData.append("status", "Accept");
    formData.append("amount", row.price);
    formData.append("seller_id", row.seller_id);

    try {
      const response = await axios.post(Base_Url + dispute_action, formData, {
        headers: {
          'Content-Type': 'application/json',
          'token': token,
          'cus_id': cus_id,
        },
      });
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Error uploading data: " + error.message);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows([...Array(actionRequiredData.length).keys()]);
      setAllSelerId([...Array(actionRequiredData.seler_id)]);
    } else {
      setSelectedRows([]);
      setAllSelerId('');
    }
    setSelectAll(e.target.checked);
  };

  const handleRowSelect = (index) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(index);
      if (isSelected) {
        return prev.filter(i => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
            <Sidebar />
          </div>
        )}
        {/* <div className="container mx-auto p-4 shadow-custom-light rounded-custom md:mt-4 md:mb-4 md:mr-4 md:ml-4 mb-2 ml-2 mr-2 mt-8 dark:shadow-custom-dark custom-scrollbar overflow-y-auto">
          <button className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 bg-customPurple hover:bg-purple-700 text-white font-sans px-2 sm:px-4 py-2 sm:py-1 rounded h-[40px] w-full sm:w-full flex items-center justify-center">
            <FaWeight className="mr-2" size={24} />
            Weight Disputes
          </button>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`px-4 py-2 mr-8 w-full mb-2 rounded dark:bg-darkmodeColor dark:text-white dark:shadow-custom-dark ${activeTab === tab.id
                  ? 'bg-customPurple hover:bg-purple-700 dark:hover:bg-purple-700 text-white dark:bg-customPurple dark:text-white'
                  : 'dark:bg-darkmodeColor dark:text-white dark:shadow-custom-dark shadow-custom-light rounded-custom'
                  }`}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
          {
            selectAll ? (
              <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4' >
                <button
                  className="px-4 py-2 w-full mr-8 mb-2 rounded bg-green-500 dark:text-white dark:shadow-custom-dark 
                  'bg-customPurple hover:bg-green-600  text-white  dark:text-white'
                  dark:text-white dark:shadow-custom-dark shadow-custom-light rounded-custom">
                  Accepted In Bulk
                </button>
                <button
                  className="px-4 py-2 mr-8 w-full mb-2 rounded bg-red-500 dark:text-white dark:shadow-custom-dark 
                  'bg-customPurple hover:bg-red-600  text-white  dark:text-white'
                  dark:text-white dark:shadow-custom-dark shadow-custom-light rounded-custom">
                  Raised In Bulk
                </button>
              </div>
            ) : ("")
          }
          <div className="overflow-x-auto shadow-custom-light rounded-custom dark:shadow-none">
            {activeTab === 'action' && (
              <div className={`rounded-custom p-4 ${isDarkMode ? "dark:bg-darkmodeColor rounded-custom text-white" : "bg-white "}`}>
                <div className='overflow-x-auto'>
                  <table className='min-w-full table-auto'>
                    <thead className='bg-[#0540a6dd] text-white text-[14px]'>
                      <tr>
                        <th className='p-2 text-left'>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                          />
                        </th>
                        <th className='p-2 text-left'>AWB No</th>
                        <th className='p-2 text-left'>Initial <br></br> Weight</th>
                        <th className='p-2 text-left'>Dimensions</th>
                        <th className='p-2 text-left'>Description</th>
                        <th className='p-2 text-left'>SKU</th>
                        <th className='p-2 text-left'>Status</th>
                        <th className='p-2 text-left'>Revised<br></br> Weight</th>
                        <th className='p-2 text-left'>Price</th>
                        <th className='p-2 text-left'>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {actionRequiredData.map((row, index) => (
                        <tr key={index} className="border-b">
                          <td className='p-2'>
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(index)}
                              onChange={() => handleRowSelect(index)}
                            />
                          </td>
                          <td className="p-4">{row.waybill}</td>
                          <td className="p-4">{row.initial_weight}</td>
                          <td className="p-4">{row.dimension}</td>
                          <td className="p-4">{row.product_des}</td>
                          <td className="p-4">{row.sku}</td>
                          <td className="p-4">{row.status}</td>
                          <td className="p-4">{row.reversed_weight}</td>
                          <td className="p-4">{row.price}</td>
                          <td className="p-4">
                            <button
                              className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                              onClick={() => handleAccept(row)}
                            >
                              Accept
                            </button>
                            <button
                              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 ml-2"
                              onClick={() => handleViewClick(row.waybill)}
                            >
                              Raise
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <StatusRaised
                  isopen={isPopupOpen}
                  onClose={handleClose}
                  waybill_no={selectedWaybillNo} />
                <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                  <span className="text-sm text-gray-700 font-bold dark:text-gray-300">{`Total Weight Disputes: ${totalCustomer}`}</span>
                  <select
                    id="limit"
                    value={limit}
                    onChange={handleLimitChange}
                    className="border rounded p-1 sm:ml-[480px] text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
                  >
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={totalCustomer}>All</option>
                  </select>
                  <Pagination
                    count={Math.ceil(totalCustomer / limit)}
                    page={currentPage}
                    onChange={handlePaginationChange}
                    variant="outlined"
                    shape="rounded"
                    className="pagination"
                    size="small"
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                      />
                    )}
                  />
                </div>
              </div>
            )}
            {activeTab === 'accepted' && (
              <div className={`rounded-custom p-4 ${isDarkMode ? "dark:bg-darkmodeColor rounded-custom text-white" : "bg-white "}`}>
                <div cla ssName='overflow-x-auto'>
                  <table className='min-w-full table-auto'>
                    <thead className='bg-[#0540a6dd] text-white text-[14px]'>
                      <tr>
                        <th className='p-2 text-left'>AWB No</th>
                        <th className='p-2 text-left'>Initial<br></br>Weight</th>
                        <th className='p-2 text-left'>Dimensions</th>
                        <th className='p-2 text-left'>Description</th>
                        <th className='p-2 text-left'>SKU</th>
                        <th className='p-2 text-left'>Revised<br></br>Weight</th>
                        <th className='p-2 text-left'>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {acceptData.map((row, index) => (
                        <tr key={index} className='border-b'>
                          <td className="p-2">{row.waybill}</td>
                          <td className="p-2">{row.initial_weight}</td>
                          <td className="p-2">{row.dimension}</td>
                          <td className="p-2">{row.product_des}</td>
                          <td className="p-2">{row.sku}</td>
                          <td className="p-2">{row.reversed_weight}</td>
                          <td className="p-2">{row.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                  <span className="text-sm text-gray-700 font-bold dark:text-gray-300">{`Total Weight Disputes: ${totalCustomer}`}</span>
                  <select
                    id="limit"
                    value={limit}
                    onChange={handleLimitChange}
                    className="border rounded p-1 sm:ml-[480px] text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
                  >
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={totalCustomer}>All</option>
                  </select>
                  <Pagination
                    count={Math.ceil(totalCustomer / limit)}
                    page={currentPage}
                    onChange={handlePaginationChange}
                    variant="outlined"
                    shape="rounded"
                    className="pagination"
                    size="small"
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                      />
                    )}
                  />
                </div>
              </div>
            )}
            {activeTab === 'disputes' && (
              <div className={`rounded-custom p-4 ${isDarkMode ? "dark:bg-darkmodeColor rounded-custom text-white" : "bg-white "}`}>
                <div className='overflow-x-auto'>
                  <table className='min-w-full table-auto'>
                    <thead className='bg-[#0540a6dd] text-white text-[14px]'>
                      <tr>
                        <th className='p-2 text-left'>AWB No</th>
                        <th className='p-2 text-left'> Initial<br></br>Weight</th>
                        <th className='p-2 text-left'>Dimensions</th>
                        <th className='p-2 text-left'>Description</th>
                        <th className='p-2 text-left'>SKU</th>
                        <th className='p-2 text-left'>Status</th>
                        <th className='p-2 text-left'>Revised <br></br> Weight</th>
                        <th className='p-2 text-left'>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allWeightDisputess.map((row, index) => (
                        <tr key={index} className='border-b'>
                          <td className="p-2">{row.waybill}</td>
                          <td className="p-2">{row.initial_weight}</td>
                          <td className="p-2">{row.dimension}</td>
                          <td className="p-2">{row.product_des}</td>
                          <td className="p-2">{row.sku}</td>
                          <td className="p-2">{row.status}</td>
                          <td className="p-2">{row.reversed_weight}</td>
                          <td className="p-2">{row.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                  <span className="text-sm text-gray-700 font-bold dark:text-gray-300">{`Total Weight Disputes: ${totalCustomer}`}</span>
                  <select
                    id="limit"
                    value={limit}
                    onChange={handleLimitChange}
                    className="border rounded p-1 sm:ml-[480px] text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
                  >
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={totalCustomer}>All</option>
                  </select>
                  <Pagination
                    count={Math.ceil(totalCustomer / limit)}
                    page={currentPage}
                    onChange={handlePaginationChange}
                    variant="outlined"
                    shape="rounded"
                    className="pagination"
                    size="small"
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                      />
                    )}
                  />
                </div>
              </div>
            )}
            {activeTab === 'closed' && (
              <div className={`rounded-custom p-4 ${isDarkMode ? "dark:bg-darkmodeColor rounded-custom text-white" : "bg-white "}`}>
                <div className='overflow-x-auto'>
                  <table className='min-w-full table-auto'>
                    <thead className='bg-[#0540a6dd] text-white text-[14px]'>
                      <tr>
                        <th className='p-2 text-left'>AWB No</th>
                        <th className='p-2 text-left'>Initial<br></br> Weight</th>
                        <th className='p-2 text-left'>Dimensions</th>
                        <th className='p-2 text-left'>Description</th>
                        <th className='p-2 text-left'>SKU</th>
                        <th className='p-2 text-left'>Status</th>
                        <th className='p-2 text-left'> Revised  <br></br>Weight</th>
                        <th className='p-2 text-left'>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {closedData.map((row, index) => (
                        <tr key={index} className='border-b'>
                          <td className="p-2">{row.waybill}</td>
                          <td className="p-2">{row.initial_weight}</td>
                          <td className="p-2">{row.dimension}</td>
                          <td className="p-2">{row.product_des}</td>
                          <td className="p-2">{row.sku}</td>
                          <td className="p-2">{row.status}</td>
                          <td className="p-2">{row.reversed_weight}</td>
                          <td className="p-2">{row.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                  <span className="text-sm text-gray-700 font-bold dark:text-gray-300">{`Total Weight Disputes: ${totalCustomer}`}</span>
                  <select
                    id="limit"
                    value={limit}
                    onChange={handleLimitChange}
                    className="border rounded p-1 sm:ml-[480px] text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
                  >
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={totalCustomer}>All</option>
                  </select>
                  <Pagination
                    count={Math.ceil(totalCustomer / limit)}
                    page={currentPage}
                    onChange={handlePaginationChange}
                    variant="outlined"
                    shape="rounded"
                    className="pagination"
                    size="small"
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                      />
                    )}
                  />
                </div>
              </div>
            )}

            {(activeTab === 'closed' || activeTab === 'accepted' || activeTab === 'disputes').lenght === 0 && (
              <p className="text-gray-600">No data available for this tab.</p>
            )}
          </div>
        </div> */}
        <div className="w-full mt-4 mb-4 mr-4 ml-4 overflow-x-hidden bg-white overflow-y-auto dark:bg-darkmodeColor custom-scrollbar dark:shadow-custom-dark shadow-custom-light rounded-custom">
          <div className="container mx-auto p-6">
            {/* Header Section */}
            <div className="mb-8">
              <div className="bg-customPurple text-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02]">
                <button className="w-full px-6 py-4 flex items-center justify-center gap-3 font-sans font-semibold text-lg sm:text-xl">
                  <FaWeight className="text-2xl" />
                  <span>Weight Disputes</span>
                </button>
              </div>
            </div>

            {/* Tabs Section */}
            <div className="mb-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {tabs.map((tab, index) => (
                  <button
                    key={tab.id}
                    className={`group relative px-6 py-4 font-sans font-medium text-sm rounded-xl transition-all duration-300 transform hover:scale-[1.02] ${activeTab === tab.id
                      ? 'bg-customPurple text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                      : 'bg-white dark:bg-[rgba(1,14,78,0.8)] text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:border-blue-300 dark:hover:border-blue-400 hover:bg-blue-50 dark:hover:bg-[rgba(1,14,78,0.9)] shadow-sm hover:shadow-md'
                      }`}
                    onClick={() => handleTabClick(tab.id)}
                  >
                    <div className="flex items-center justify-center gap-2">
                      {/* Add icons based on tab type */}
                      {tab.id === 'action' && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      )}
                      {tab.id === 'accepted' && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      )}
                      {tab.id === 'disputes' && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                      )}
                      {tab.id === 'closed' && (
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                        </svg>
                      )}
                      <span>{tab.label}</span>
                    </div>

                    {/* Active tab indicator */}
                    {activeTab === tab.id && (
                      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-12 h-0.5 bg-white rounded-full"></div>
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* Bulk Actions Section */}
            {selectAll && (
              <div className="mb-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <button className="group relative px-6 py-3 font-sans font-medium text-sm rounded-xl transition-all duration-300 transform hover:scale-[1.02] bg-gradient-to-r from-green-500 to-green-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40">
                    <div className="flex items-center justify-center gap-2">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Accepted In Bulk</span>
                    </div>
                  </button>
                  <button className="group relative px-6 py-3 font-sans font-medium text-sm rounded-xl transition-all duration-300 transform hover:scale-[1.02] bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40">
                    <div className="flex items-center justify-center gap-2">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                      </svg>
                      <span>Raised In Bulk</span>
                    </div>
                  </button>
                </div>
              </div>
            )}

            {/* Table Section */}
            <div className="bg-white dark:bg-darkmodeColor rounded-xl shadow-sm overflow-hidden">
              {activeTab === 'action' && (
                <div className="overflow-x-auto">
                  <table className="min-w-full table-auto custom-scrollbar overflow-y-auto">
                    <thead className="bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white">
                      <tr>
                        <th className='p-2 text-left'>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                          />
                        </th>
                        <th className="p-2 text-left font-medium">AWB No</th>
                        <th className="p-2 text-left font-medium">Initial<br />Weight</th>
                        <th className="p-2 text-left font-medium">Dimensions</th>
                        <th className="p-2 text-left font-medium">Description</th>
                        <th className="p-2 text-left font-medium">SKU</th>
                        <th className="p-2 text-left font-medium">Status</th>
                        <th className="p-2 text-left font-medium">Revised<br />Weight</th>
                        <th className="p-2 text-left font-medium">Price</th>
                        <th className="p-2 text-left font-medium">Action</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                      {actionRequiredData.map((row, index) => (
                        <tr
                          key={index}
                          className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                            ? 'bg-white dark:bg-darkmodeColor'
                            : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                            }`}
                        >
                          <td className='p-2'>
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(index)}
                              onChange={() => handleRowSelect(index)}
                            />
                          </td>
                          <td className="p-2 text-xs text-blue-600 dark:text-blue-400 font-medium">{row.waybill}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.initial_weight}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.dimension}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.product_des}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.sku}</td>
                          <td className="p-2">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200">
                              {row.status}
                            </span>
                          </td>
                          <td className="p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold">{row.reversed_weight}</td>
                          <td className="p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold">₹{row.price}</td>
                          <td className="p-2">
                            <div className="flex items-center gap-1">
                              <button
                                className="px-3 py-1 bg-gradient-to-r from-green-500 to-green-600 text-white text-xs rounded-md hover:from-green-600 hover:to-green-700 transition-all duration-200 shadow-sm hover:shadow-md"
                                onClick={() => handleAccept(row)}
                              >
                                Accept
                              </button>
                              <button
                                className="px-3 py-1 bg-gradient-to-r from-red-500 to-red-600 text-white text-xs rounded-md hover:from-red-600 hover:to-red-700 transition-all duration-200 shadow-sm hover:shadow-md"
                                onClick={() => handleViewClick(row.waybill)}
                              >
                                Raise
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {activeTab === 'accepted' && (
                <div className="overflow-x-auto">
                  <table className="min-w-full table-auto custom-scrollbar overflow-y-auto">
                    <thead className="bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white">
                      <tr>
                        <th className="p-2 text-left font-medium">AWB No</th>
                        <th className="p-2 text-left font-medium">Initial<br />Weight</th>
                        <th className="p-2 text-left font-medium">Dimensions</th>
                        <th className="p-2 text-left font-medium">Description</th>
                        <th className="p-2 text-left font-medium">SKU</th>
                        <th className="p-2 text-left font-medium">Revised<br />Weight</th>
                        <th className="p-2 text-left font-medium">Price</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                      {acceptData.map((row, index) => (
                        <tr
                          key={index}
                          className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                            ? 'bg-white dark:bg-darkmodeColor'
                            : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                            }`}
                        >
                          <td className="p-2 text-xs text-blue-600 dark:text-blue-400 font-medium">{row.waybill}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.initial_weight}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.dimension}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.product_des}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.sku}</td>
                          <td className="p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold">{row.reversed_weight}</td>
                          <td className="p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold">₹{row.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {activeTab === 'disputes' && (
                <div className="overflow-x-auto">
                  <table className="min-w-full table-auto custom-scrollbar overflow-y-auto">
                    <thead className="bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white">
                      <tr>
                        <th className="p-2 text-left font-medium">AWB No</th>
                        <th className="p-2 text-left font-medium">Initial<br />Weight</th>
                        <th className="p-2 text-left font-medium">Dimensions</th>
                        <th className="p-2 text-left font-medium">Description</th>
                        <th className="p-2 text-left font-medium">SKU</th>
                        <th className="p-2 text-left font-medium">Status</th>
                        <th className="p-2 text-left font-medium">Revised<br />Weight</th>
                        <th className="p-2 text-left font-medium">Price</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                      {allWeightDisputess.map((row, index) => (
                        <tr
                          key={index}
                          className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                            ? 'bg-white dark:bg-darkmodeColor'
                            : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                            }`}
                        >
                          <td className="p-2 text-xs text-blue-600 dark:text-blue-400 font-medium">{row.waybill}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.initial_weight}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.dimension}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.product_des}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.sku}</td>
                          <td className="p-2">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200">
                              {row.status}
                            </span>
                          </td>
                          <td className="p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold">{row.reversed_weight}</td>
                          <td className="p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold">₹{row.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {activeTab === 'closed' && (
                <div className="overflow-x-auto">
                  <table className="min-w-full table-auto custom-scrollbar overflow-y-auto">
                    <thead className="bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white">
                      <tr>
                        <th className="p-2 text-left font-medium">AWB No</th>
                        <th className="p-2 text-left font-medium">Initial<br />Weight</th>
                        <th className="p-2 text-left font-medium">Dimensions</th>
                        <th className="p-2 text-left font-medium">Description</th>
                        <th className="p-2 text-left font-medium">SKU</th>
                        <th className="p-2 text-left font-medium">Status</th>
                        <th className="p-2 text-left font-medium">Revised<br />Weight</th>
                        <th className="p-2 text-left font-medium">Price</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                      {closedData.map((row, index) => (
                        <tr
                          key={index}
                          className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                            ? 'bg-white dark:bg-darkmodeColor'
                            : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                            }`}
                        >
                          <td className="p-2 text-xs text-blue-600 dark:text-blue-400 font-medium">{row.waybill}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.initial_weight}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.dimension}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.product_des}</td>
                          <td className="p-2 text-xs text-gray-700 dark:text-gray-300 font-medium">{row.sku}</td>
                          <td className="p-2">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                              {row.status}
                            </span>
                          </td>
                          <td className="p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold">{row.reversed_weight}</td>
                          <td className="p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold">₹{row.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Pagination Section */}
              <div className="px-6 py-4 border-t border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-[rgba(1,14,78,0.8)]">
                <div className="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
                  <span className="text-sm text-gray-600 dark:text-gray-300 font-medium">
                    Total Weight Disputes: <span className="font-bold text-gray-900 dark:text-white">{totalCustomer}</span>
                  </span>
                  <div className="flex items-center gap-4">
                    <select
                      id="limit"
                      value={limit}
                      onChange={handleLimitChange}
                      className="border border-gray-300 dark:border-gray-600 rounded-lg px-1 py-1 text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={totalCustomer}>All</option>
                    </select>
                    <Pagination
                      count={Math.ceil(totalCustomer / limit)}
                      page={currentPage}
                      onChange={handlePaginationChange}
                      variant="outlined"
                      shape="rounded"
                      className="pagination"
                      size="small"
                      renderItem={(item) => (
                        <PaginationItem
                          {...item}
                          className={`mx-1 rounded-md transition-all duration-200 ${item.selected
                            ? 'bg-customPurple text-white shadow-md'
                            : 'text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-[rgba(1,14,78,0.9)]'
                            }`}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>

            <StatusRaised
              isopen={isPopupOpen}
              onClose={handleClose}
              waybill_no={selectedWaybillNo}
            />

            {/* No Data Message */}
            {/* {(activeTab === 'closed' || activeTab === 'accepted' || activeTab === 'disputes') &&
              (closedData?.length === 0 || acceptData?.length === 0 || allWeightDisputess?.length === 0) && (
                <div className="text-center py-12">
                  <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-gray-100">No data available</h3>
                  <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">No data available for this tab.</p>
                </div>
              )} */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default WeightDisputeDashboard;